/* Core */
import React from "react";
import Modal from "react-modal";

/* Components */
import Spinner from "../general/Spinner";

const LoaderModal = () => {
  return (
    <Modal
      appElement={document.getElementById("react-root")!}
      className="LoaderModal flex"
      isOpen
      overlayClassName="Modal-overlay"
    >
      <Spinner />
    </Modal>
  )
}

export default LoaderModal;
